import { takeLatest, call, put } from 'redux-saga/effects';
import { DELETE_ENTERPRISES_START, DELETE_ENTERPRISES_ERROR, DELETE_ENTERPRISES_SUCCESS, GET_ENTERPRISES_START } from '../../types';

import apiCall from '../../../api/apiGet';

export function* del({ payload }) {
  try {
    const url = `/enterprises/delete/${payload.id}`;
    const method = 'DELETE';
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, headers);
    console.log(results)
    yield put({ type: DELETE_ENTERPRISES_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: DELETE_ENTERPRISES_ERROR, error });
  } finally {
    yield put({ type: GET_ENTERPRISES_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* delete_enterprises() {
  yield takeLatest(DELETE_ENTERPRISES_START, del);
}
